import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import MaintenanceContent from './MaintenanceContent';
import MaintenanceGeneral from './MaintenanceGeneral';
import { SaveAndBackButtons } from '../../components/base/BottomStepComponent';
import ContentSections from '../../components/base/ContentSections';
import { APIStatus } from 'config/CustomEnums';
import Loading from 'components/base/Loading';
import './MaintenanceStepOne.scss';


const MaintenanceStepOne = ({
  loadingStatus,
  languages,
  setShowCompleteProcess,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getValues } = useFormContext();

  useEffect(() => {
    dispatch({
      type: 'language/getList',
      payload: {
        isSelectorLoad: true,
      }
    });
  }, [dispatch]);

  const getLanguageTab = (language) => {
    return [<MaintenanceContent language={language} />];
  };

  const languageTabConfig = {
    containers: languages?.map((item) => ({
      container: getLanguageTab(item.code),
      key: item.code,
      title: item.sourceName,
    })),
  };

  const save = () => {
    console.log('@@75', getValues());
    dispatch({
      type: 'maintenance/updateMaintenance',
      payload: {
        values: getValues(),
        afterActions: () => {
          setShowCompleteProcess(true);
        },
      }
    });
  };

  if (loadingStatus === APIStatus.calling) {
    return <Loading />
  };

  return (
    <>
      <ContentSections
        contentStyle="maintenance-step-one-general-section"
        sections={[<MaintenanceGeneral />]}
        hidePreview={true}
      />

      <ContentSections
        languageTabContent={languageTabConfig}
        hidePreview
      />

      <SaveAndBackButtons
        backAction={() => {
          history.goBack();
        }}
        saveText={'Save'}
        saveAction={save}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  loadingStatus: state.maintenance.loadingStatus,
  languages: state.language.allList,
})

export default connect(mapPropsToState)(MaintenanceStepOne);
